// import { CloseButton, PopupDefault } from '../ReusableComponents/PopupDefault';
// import Subscribe from '../Popups/Subscribe';
// import LoginToUpgrade from './LoginToUpgrade';
// import { useAuthUserAndMembership } from './useAuthUserAndMembership';

// const AuthUserAndMembership = () => {
//   const {
//     showLoginPopup,
//     showSubscribePopup,
//     closeLoginPopup,
//     closeSubscribePopup
//   } = useAuthUserAndMembership();

//   return (
//     <>
//       {/* Login Popup - shown when user is not logged in */}
//       {showLoginPopup && (
//         <LoginToUpgrade onClose={closeLoginPopup} />
//       )}

//       {/* Subscribe Popup - shown when user is logged in but not a member */}
//       {showSubscribePopup && (
//         <PopupDefault onClose={closeSubscribePopup}>
//           <CloseButton onClose={closeSubscribePopup} />
//           <Subscribe />
//         </PopupDefault>
//       )}
//     </>
//   );
// };

// export default AuthUserAndMembership;

















import { CloseButton, PopupDefault } from '../ReusableComponents/PopupDefault';
import Subscribe from '../Popups/Subscribe';
import LoginToUpgrade from './LoginToUpgrade';
import { useAuthUserAndMembership } from './useAuthUserAndMembership';

const AuthUserAndMembership = () => {
  const {
    showLoginPopup,
    showSubscribePopup,
    closeLoginPopup,
    closeSubscribePopup,
    hasActiveLicense,
    hadActiveLicense
  } = useAuthUserAndMembership();

  return (
    <>
      {/* Login Popup - shown when user is not logged in */}
      {showLoginPopup && (
        <LoginToUpgrade onClose={closeLoginPopup} />
      )}

      {/* Subscribe Popup - shown when user is logged in but not a member */}
      {showSubscribePopup && (
        <PopupDefault onClose={closeSubscribePopup}>
          <CloseButton onClose={closeSubscribePopup} />
          <Subscribe
            hasActiveLicense={hasActiveLicense}
            hadActiveLicense={hadActiveLicense}
          />
        </PopupDefault>
      )}
    </>
  );
};

export default AuthUserAndMembership;